import translationsDE_countries from "../i18n/translations/de-DE_countries.json";
// list all countries we have a german translation for

const countries = Object.keys(translationsDE_countries.names).filter(
  (key) => !key.startsWith("_")
);

export default countries;
